import Client from '../services/kenticoClient';
import { KENTICO_TYPES } from '../common/consts/kentico';
import { SortOrder } from 'kentico-cloud-delivery';

class HistoryService {
  async fetchHistories() {
    const query = Client.items()
      .type(KENTICO_TYPES.HISTORY)
      .orderParameter('elements.data', SortOrder.desc);

    return await query.toPromise();
  }
}

export default new HistoryService();



// WEBPACK FOOTER //
// ./src/services/History.service.js